// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"c2385dc1","830":"e098fedb","925":"765b3130"}[chunkId] + ".chunk.js";
};